"use client";

import { useQuery } from "@tanstack/react-query";

import { allQueryKeys } from "#app/_api/allQueryKeys";
import type { GetMessagePageData } from "#app/_api/bol-authentication-service/get-message-page";
import { useOutageBypass } from "#app/_ui/components/outages/use-outage-bypass";
import { logError } from "#app/lib/logger";
import { TimeSpan } from "#app/lib/TimeSpan";

function selectPageMessageByPath({
  data,
  path,
}: UsePageMessageParams & { data: GetMessagePageData }): UsePageMessageData {
  const match = data.find((el) => el.path === path);
  if (
    match &&
    ((typeof match.statusMessage === "string" &&
      match.statusMessage.length > 0) ||
      match.isAvailable === false)
  ) {
    return match;
  }
  return undefined;
}

type UsePageMessageParams = { path: string };
export type UsePageMessageData = GetMessagePageData[number] | undefined;

export function usePageMessage(
  params: UsePageMessageParams,
): UsePageMessageData {
  const outageBypass = useOutageBypass();

  const {
    data: pageStatuses,
    error,
    isError,
  } = useQuery({
    ...allQueryKeys.bolAuthenticationService.messagePage,
    staleTime: TimeSpan.fromMinutes(1).totalMilliseconds,
    select: (data) => selectPageMessageByPath({ ...params, data }),
  });

  if (isError) {
    logError(error);
  }

  if (pageStatuses != null) {
    return {
      ...pageStatuses,
      isAvailable: outageBypass ? true : pageStatuses.isAvailable,
    };
  }

  return undefined;
}
